import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios';
import apiService from '../../../common/api.service';
import * as dom from "../../models/domain";

export const getOnlineContactsThunk = createAsyncThunk(
    'chats/online-users',
    async () => {
        try {           
            const response = await apiService.get('/chats/online-users')
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error getting chats');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const getContactsThunk = createAsyncThunk(
    'chats/contacts',
    async (data: dom.ChatsQuery) => {
        try {           
            const response = await apiService.post<dom.ChatsQuery>('/chats/contacts', data) as AxiosResponse<dom.StaffMemberRef[]>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error getting chats');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const getChatsThunk = createAsyncThunk(
    'chats',
    async (data: dom.ChatsQuery) => {
        try {           
            const response = await apiService.post<dom.ChatsQuery>('/chats', data) as AxiosResponse<dom.ChatResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error getting chats');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const getParticipantChatsThunk = createAsyncThunk(
    'chatmessages',
    async (data: dom.ChatMessageQuery) => {
        try {           
            const response = await apiService.post<dom.ChatsQuery>('/chatmessages', data) as AxiosResponse<dom.ChatMessageResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error getting chat messages');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const createChatThunk = createAsyncThunk(
    'chats/create',
    async (data: dom.ChatMessagePayload) => {
        try {           
            const response = await apiService.post<dom.ChatMessagePayload>('/chats/create', data) as AxiosResponse<dom.ChatMessageResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error chat');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const updateChatThunk = createAsyncThunk(
    'chats/update',
    async (data: dom.ChatPayload) => {
        try {           
            const response = await apiService.post<dom.ChatPayload>('/chats/update', data) as AxiosResponse<dom.ChatResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error chat');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const sendMessageThunk = createAsyncThunk(
    'chat/message/send',
    // if you type your function argument here
    async (data: dom.ChatMessagePayload) => {
        try {           
            const response = await apiService.post<dom.ChatMessagePayload>('/chatmessages/sendmessage', data) as AxiosResponse<dom.ChatMessageResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error chat message reaction');
            }
        } catch (error) {
            if (error?.response?.data?.errors) throw new Error(error?.response?.data?.errors)
            else throw error
        }
    }
)

export const sendMessageReactionThunk = createAsyncThunk(
    'chat/message/reaction',
    // if you type your function argument here
    async (data: dom.MessageReactionPayload) => {
        try {           
            const response = await apiService.post<dom.MessageReactionPayload>('/chatmessages/reaction', data) as AxiosResponse<dom.ChatMessageResponse>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error updating system acknowledgements');
            }
        } catch (error) {
            if (error?.response?.data?.errors) throw new Error(error?.response?.data?.errors)
            else throw error
        }
    }
)


export const saveContactWaiverThunk = createAsyncThunk(
    'chats/savewaiver',
    async (data: dom.ContactWaiver) => {
        try {           
            const response = await apiService.post<dom.ContactWaiver>('/chats/savewaiver', data) as AxiosResponse<dom.StaffMember>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error getting chats');
            }
        } catch (error) {
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)